/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 8:46 AM
 */

/* eslint-disable*/
import React from "react";
// core components
import './TeacherVersion01.scss';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import * as instituteService from "../../../../services/institute";
import * as commonFunc from "../../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../../store/domain/classes/action";
import * as actionLectureCreator from "../../../../store/domain/lecturer/action";
import * as constants from "../../../../const/constants";
import webConfig from '../../../../config/WebConfig';
import {Col, Container, Row} from "reactstrap";
import CourseSlides from "../../../../components/CourseSlides/CourseSlides";
import NotFound from "../../../../components/NotFound/NotFound";
import CourseSlidesV2 from "../../../../components/CourseSlides/CourseSlidesV2";
import ViberHeader from "../../../../components/header-new/ViberHeader";
import d2 from "../../../../assets/img/revamp/vibernets/landing/D1.jpg"
import ReactPlayer from "react-player";
// import coverIMG from "../../../../assets/img/revamp/vibernets/cover.png"

class Teacher extends React.Component {

    state = {
        lessons: [],
        classes: [],
        courses: [],
        privileges: '0',
        new: {
            lecturer: {
                "id": 0,
                "name": "",
                "gender": "",
                "description": "",
                "dob": "1998-09-21",
                "email": "",
                "mobile": "",
                "qualification": "B.Sc. Engineering (Hons.) in Electronics & Telecommunication Engineering, University of Moratuwa",
                "zoomUserId": "",
                "status": "ACTIVE",
                "imageUrl": "",
                "maxEnrolls": 1000,
                "privileges": "1:1:1:1",
                "bankNumber": "",
                "bankName": "",
                "branchName": "",
                "accHolderName": "",
                "urlName": "",
                "coverImage": ""
            }
        }
    }

    fetchClassesFromHome = async () => {
        let state = this.props.match.params.teacher_name;
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 15});
            await instituteService.getTeacherDetails(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        let body = response.body;
                        let data = [{
                            classes: body.classes,
                            teacherId: body.id,
                            courses: body.courses,
                            teacherName: body.name
                        }];
                        this.props.fetchLecture({
                            name: body.name,
                            about: body.description,
                            image: body.imageUrl,
                            defaultImage: '',
                            qualification: body.qualification,
                            coverImage: body.coverImage,
                            privileges: body.privileges
                        });
                        this.props.fetchLectures(data);
                        this.setState({
                            lessons: body.lessons,
                            classes: body.classes,
                            courses: body.courses,
                            privileges: body.privileges.split(':')[1]
                        })
                    } else {
                        commonFunc.notifyMessage(response.message, response.status)
                    }
                })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
        }
    };

    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        console.log(this.props);
        if (webConfig.LMSStatus === 'LMS') {
            this.fetchClassesFromHome();
        } else {
            let data = this.props.location.state;
            console.log(data);
            this.props.fetchLecture({
                name: data.name,
                about: data.description,
                image: data.imageUrl,
                defaultImage: '',
                qualification: data.qualification,
                coverImage: data.coverImage,
                privileges: data.privileges
            });
            console.log(data.classes);
            this.setState({
                //   lessons: data.lessons,
                classes: data.classes,
                //  privileges: data.privileges.split(':')[1]
            })
        }
    }

    render() {
        let {lecturer, listOfLectures, userType} = this.props;

        if (this.state.classes && this.state.classes !== 0) {
            this.state.classes.sort(function (a, b) {
                return a.id - b.id
            });
        }

        // console.log(this.state.classes);
        const cover = 'https://assets.edulab.lk/common-assets/banner-bg.jpg';

        return (
            <div>
                <ViberHeader showShadow={true}/>
                <main ref="main" className={"main"}>
                    <Container fluid={"sm"} className={""}
                               style={{marginTop: 20, paddingLeft: "7.5%", paddingRight: "7.5%"}}>

                        <Row style={{display:'flex',flexDirection:"column",alignItems:'center',justifyContent:'center'}}>
                            <Col sm={9} md={6} lg={6} xl={3}>
                                <img style={{boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",width:'100%',objectFit:'cover',aspectRatio:'4/4',borderRadius:10}} src={"https://dev-resources.edulab.lk/static/teacher-profile/Profile.jpg"} alt={""}/>
                            </Col>
                        </Row>

                        <Row style={{marginTop:15}}>
                            <Col style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",

                            }}>
                                {/*<img*/}
                                {/*    src={coverIMG}*/}
                                {/*    alt={"."}*/}
                                {/*    className={""}*/}
                                {/*    style={{*/}
                                {/*        objectFit: "fill",*/}
                                {/*        width: "100%", borderRadius: 20,*/}
                                {/*        aspectRatio: '3 / 0.2',*/}
                                {/*    }}/>*/}

                                {/*<img*/}
                                {/*    src={"https://dev-resources.edulab.lk/static/teacher-profile/Profile.jpg"}*/}
                                {/*    style={{*/}
                                {/*        width: "25%",*/}
                                {/*        borderRadius: 8,*/}
                                {/*        // position: "absolute",*/}
                                {/*        aspectRatio: '3 / 3',*/}
                                {/*        objectFit: "cover",*/}
                                {/*        // top: 650,*/}
                                {/*        // position: "relative",*/}
                                {/*        // top: "-15%",*/}
                                {/*    }} className={""}*/}
                                {/*    alt="."/>*/}

                                <Container style={{marginTop: "0px"}}>
                                    <Col style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center"
                                    }}>
                                        <div style={{display: "flex", flexDirection: "column", gap: 10}}>
                                            <div className={""} style={{
                                                fontSize: 35,
                                                fontWeight: 'bold',
                                                color: "black"
                                            }}>{lecturer.name}</div>
                                            <div>Trainer | Network Engineer</div>
                                            <div className={""} style={{fontWeight:'bold',fontSize:'1.1rem'}}>{lecturer.qualification}</div>
                                            <div style={{
                                                paddingLeft: "10%",
                                                color: "black",
                                                paddingRight: "10%",
                                                textAlign:"justify",
                                                fontSize:'20px'
                                            }}>
                                                Wenura Mendis is a network expert with over 15 years of experience as a CCNA and CCNP trainer.
                                                With more than 20 certifications in CCNA, CCNP, CKA, PCNSE, CEH, Juniper x5, Oracle x5, AWS
                                                x1, and Azure x1, Wenura has guided thousands of students to earn their professional
                                                certifications and launch successful IT careers. As a respected trainer for leading internet
                                                service providers in Sri Lanka, his hands-on approach goes beyond theory, providing practical
                                                insights that prepare students for real-world challenges.
                                                {/*{lecturer.about}*/}
                                            </div>
                                            <div style={{
                                                paddingLeft: "10%",
                                                color: "black",
                                                paddingRight: "10%",
                                                textAlign:"justify",
                                                fontSize:'20px'
                                            }}>
                                                Wenura is a leading network trainer at Vibernets Academy, a Udemy trainer,
                                                and an active YouTuber on the Vibernets Streaming channel. He shares the latest
                                                tech updates and empowers his students with the skills they need to excel
                                                in the dynamic world of networking.
                                            </div>
                                        </div>
                                    </Col>
                                </Container>
                            </Col>
                        </Row>

                        {
                            this.state.classes.length === 0 && this.state.courses.length === 0 && !this.props.isSpinner &&
                            <Row style={{padding: "5%"}}>
                                <Col>
                                    <NotFound message={`Available classes`}/>
                                </Col>
                            </Row>
                        }

                        {/*{*/}
                        {/*    this.state.classes.length !== 0 && <Row style={{paddingTop: 40}}>*/}
                        {/*        <Col>*/}
                        {/*            {*/}
                        {/*                this.state.classes.length !== 0 &&*/}
                        {/*                <section className="container class-section">*/}
                        {/*                    <div style={{*/}
                        {/*                        textAlign: "center",*/}
                        {/*                        color: "black",*/}
                        {/*                        fontWeight: "bold",*/}
                        {/*                        fontSize: "3rem"*/}
                        {/*                    }}>*/}
                        {/*                        {lecturer.name}'s Classes*/}
                        {/*                    </div>*/}
                        {/*                    /!* <h3 className={"class-ctrl"}>Classes</h3> *!/*/}
                        {/*                    <CourseSlides classesByLecture={this.state.classes}*/}
                        {/*                                  privileges={this.state.privileges}/>*/}
                        {/*                </section>*/}
                        {/*            }*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*}*/}

                        {/*{*/}
                        {/*    this.state.courses.length !== 0 && <Row style={{paddingTop: 40}}>*/}
                        {/*        <Col>*/}
                        {/*            {*/}
                        {/*                this.state.courses.length !== 0 &&*/}
                        {/*                <section className="container class-section">*/}
                        {/*                    <div style={{*/}
                        {/*                        textAlign: "center",*/}
                        {/*                        color: "black",*/}
                        {/*                        fontWeight: "bold",*/}
                        {/*                        fontSize: "3rem"*/}
                        {/*                    }}>*/}
                        {/*                        {lecturer.name}'s Courses*/}
                        {/*                    </div>*/}
                        {/*                    /!* <h3 className={"class-ctrl"}>Classes</h3> *!/*/}
                        {/*                    <CourseSlidesV2 courses={this.state.courses}*/}
                        {/*                                    classesByLecture={this.state.classes}*/}
                        {/*                                    privileges={this.state.privileges}/>*/}
                        {/*                </section>*/}
                        {/*            }*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*}*/}
                        {/*<Row  style={{paddingTop: 60}} className={"no-gutters"}>*/}
                        {/*    <Col xl={12} style={{*/}
                        {/*        textAlign: "center",*/}
                        {/*        color: "black",*/}
                        {/*        fontWeight: "bold",*/}
                        {/*        fontSize: "35px",*/}
                        {/*        display:'flex',*/}
                        {/*        justifyContent:'center',*/}

                        {/*    }}>*/}
                        {/*        Lecture Experience*/}
                        {/*    </Col>*/}
                        {/*    <Col style={{display:'flex',justifyContent:'start',paddingLeft:'18%',paddingRight:'18%'}}>*/}
                        {/*        <ul type={'square'}*/}
                        {/*            style={{padding:0,display:'flex',textAlign:'justify',color:'black',flexDirection:'column',justifyContent:'center',alignItems:'start',gap:8,fontSize:'20px',paddingTop:15}}>*/}
                        {/*            <li>*/}
                        {/*                For the last 15 years, my main focus has been the delivery of networking &*/}
                        {/*                Cyber Security training and the development of course content for large*/}
                        {/*                enterprises and leading internet service providers such as Dialog & Mobitel.*/}
                        {/*                I train many engineering professionals who design and implement network solutions*/}
                        {/*                throughout the world.*/}
                        {/*            </li>*/}
                        {/*            <li>*/}
                        {/*                Prior to focusing on training, I worked in the field for over 10 years in a variety of systems and network engineering and IT management roles.*/}
                        {/*            </li>*/}
                        {/*        </ul>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}

                        <Row  style={{paddingTop: 60}} className={"no-gutters"}>
                            <Col xl={12} style={{
                                textAlign: "center",
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "35px",
                                display:'flex',
                                justifyContent:'center',

                            }}>
                                Areas of Expertise
                                {/*License & Certificates*/}
                            </Col>
                            <Col style={{display:'flex',justifyContent:'start',paddingLeft:'18%',paddingRight:'18%'}}>
                                <ul type={'square'}
                                    style={{padding:0,display:'flex',color:'black',flexDirection:'column',justifyContent:'center',alignItems:'start',gap:8,fontSize:'20px',paddingTop:15}}>
                                    <li>Cisco Certified Network Professional Enterprise (CCNP Enterprise)</li>
                                    <li>
                                        CCNA Routing & Switching
                                    </li>
                                    <li>
                                        Cisco Certified DevNet Associate (200-901)
                                    </li>
                                    <li>
                                        Certified Ethical Hacker (CEH)
                                    </li>
                                    <li>
                                        PCNSE - Palo Alto Networks Certified Network Security Engineer
                                    </li>
                                    <li>
                                        2x AWS (Amazon Web Services)
                                    </li>
                                    <li>
                                        1x Azure
                                    </li>
                                    <li>
                                        5x OCI (Oracle Cloud Infrastructure)
                                    </li>
                                    <li>
                                        5x JNCIA (Juniper Networks Certified)
                                    </li>
                                    <li>
                                        Aviatrix Certified Engineer - Multi-Cloud Network Associate
                                    </li>
                                </ul>
                            </Col>
                        </Row>

                        <Row style={{marginTop:60,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}} className={"no-gutters"}>
                            <Col xl={12} style={{
                                textAlign: "center",
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "35px",
                                display:'flex',
                                justifyContent:'center',

                            }}>
                                Learn from Udemy
                            </Col>
                            <Col xl={8} style={{border:'1px solid none',paddingTop:'10px'}}>
                                <a href={"https://www.udemy.com/user/wenura-mendis/"} target={"_blank"}>
                                    <img style={{width:'100%',borderRadius:'8px'}} alt={"UDEMY"} src={"https://dev-resources.edulab.lk/static/teacher-profile/Udemy.jpg"}/>
                                </a>
                            </Col>
                        </Row>

                        {
                            <Row style={{paddingTop: 60,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',gap:25}} className={"no-gutters"}>
                                <Col xl={12} style={{
                                    textAlign: "center",
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "35px"
                                }}>
                                    Watch Our Youtube
                                </Col>
                                <Col xl={6} className={""}>
                                    <div>
                                        <ReactPlayer controls={true} width={"100%"} height={500} style={{width:'100%'}}
                                                     url={"https://youtu.be/ueQiL_AsGkA"}/>
                                    </div>
                                </Col>
                                <Col xl={6} className={""}>
                                    <div>
                                        <ReactPlayer controls={true} width={"100%"} height={500} style={{width:'100%'}}
                                                     url={"https://youtu.be/u2KM-UImxeM"}/>
                                    </div>
                                </Col>
                            </Row>
                        }

                    </Container>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lecturer: state.lecturer.lecturer,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    isSpinner: state.spinner.isSpinner,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchLectures: data => dispatch(actionClassCreator.fetchLectures(data)),
    fetchLecture: data => dispatch(actionLectureCreator.fetchLecture(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Teacher));
